// Bonuses
$(function() {
    const stepDepositButtons =
        $('#personal-cabinet__dashboard-desktop-promotions-wrapper .bonus-manager__deposit-button, ' +
        '#personal-cabinet__dashboard-mobile-promotions-wrapper .bonus-manager__deposit-button');

    $('body').on('mainCurrencyChangeComplete', (e, accounts) => {
        const mainAccount = accounts.find(account => account.main);
        if (!mainAccount) return;

        stepDepositButtons.each((idx, button) => {
            const stepId = button.getAttribute('data-step-id');
            const currencyInfo = bonusManager.getCurrencyBreakdown(stepId, mainAccount.currency);
            const newAmount = (currencyInfo.min_deposit_amount_cents ?? 0) / (currencyInfo.subunits_to_unit ?? 100);
            button.setAttribute('data-amount', newAmount);
        });
    });

    // General Functionality

    const modal = $('#personal-modal');
    if (!modal.length) return;

    const activeSections = $('#cabinet-dashboard__promotions-active--desktop, #cabinet-dashboard__promotions-active--mobile');
    const inactiveSections = $('#cabinet-dashboard__promotions-available--desktop, #cabinet-dashboard__promotions-available--mobile');
    const wrappers = $('#cabinet-dashboard__promotions-main-wrapper--desktop, #cabinet-dashboard__promotions-main-wrapper--mobile');
    const desktopSimpleBar = new SimpleBar(wrappers[0]);
    const mobileSimpleBar = new SimpleBar(wrappers[1]);

    const personalDepositButton = $('#cabinet-dashboard__promotions-available--desktop .playfina__deposit-button:not(.bonus-manager__deposit-button), ' +
        '#cabinet-dashboard__promotions-available--mobile .playfina__deposit-button:not(.bonus-manager__deposit-button)');

    const populateDepositButtonAmount = (currency) => {
        personalDepositButton.each(function() {
            const element = $(this);
            switch (element.data('bonus-code')) {
                case firstBonusCode:
                    element.attr('data-amount', firstBonusCurrenciesData[currency].min ?? '');
                    break;
                case secondBonusCode:
                    element.attr('data-amount', secondBonusCurrenciesData[currency].min ?? '');
                    break;
                case thirdBonusCode:
                    element.attr('data-amount', thirdBonusCurrenciesData[currency].min ?? '');
                    break;
                case fourthBonusCode:
                    element.attr('data-amount', fourthBonusCurrenciesData[currency].min ?? '');
                    break;
                case wednesdayBonusCode:
                    if (! element.hasClass("get-bonus-link")) {
                        element.attr('data-amount', wednesdayBonusCurrenciesData[currency].min ?? '');
                    }
                    break;
                case weekendBonusCode:
                    if (! element.hasClass("get-bonus-link")) {
                        element.attr('data-amount', weekendBonusCurrenciesData[currency].min ?? '');
                    }
                    break;
            }
        });
    }

    const generateActiveBonusHtml = (bonus) => {
        let validUntil = '';
        let validUntilDate = null;
        if (bonus.valid_until) {
            validUntilDate = new Date(bonus.valid_until);
            validUntil = ('0' + validUntilDate.getDate()).slice(-2) + '.' + ('0' + (validUntilDate.getMonth() + 1)).slice(-2) + '.' + validUntilDate.getFullYear();
        } else {
            validUntil = '--';
        }

        let timerSeconds = 0;
        if (validUntilDate) {
            let now = new Date();
            timerSeconds = Math.floor(Math.abs(validUntilDate - now) / 1000);
        }

        let image = '/dist/playfina_new/images/icons/verification-active.svg', statusText = '';
        let buttonsHtml = '';
        switch(bonus.status) {
            case BONUS.STATUSES.CREATED:
            case BONUS.STATUSES.ISSUED:
                image = '/dist/playfina_new/images/icons/bonus-not-confirmed.svg';
                statusText = translationsArray.issued;
                buttonsHtml += '<div class="row no-gutters mt-15">';
                buttonsHtml += '<div class="col-6 pr-5"><button style="width: 100%; height: 100%" class="cabinet-bonuses__activate-button d-block deposit-button text-white text-center fz-14 fw-600" data-id="' + bonus.api_id + '" data-type="' + bonus.type + '">' + translationsArray.activate + '</button></div>';
                buttonsHtml += '<div class="col-6 pl-5"><button class="cabinet-bonuses__cancel-button save-button c-200 fz-15 fw-600" data-id="' + bonus.api_id + '" data-type="' + bonus.type + '">' + translationsArray.cancel + '</button></div>';
                buttonsHtml += '</div>';
                break;
            case BONUS.STATUSES.EXPIRED:
                statusText = translationsArray.expired;
                image = '/dist/playfina_new/images/icons/bonus-required.svg';
                break;
            case BONUS.STATUSES.LOST:
                statusText = translationsArray.lost;
                image = '/dist/playfina_new/images/icons/bonus-required.svg';
                break;
            case BONUS.STATUSES.FORFEITURE:
                statusText = translationsArray.cancelled;
                image = '/dist/playfina_new/images/icons/bonus-required.svg';
                break;
            case BONUS.STATUSES.COMPLETED:
                image = '/dist/playfina_new/images/icons/verification-active.svg';
                statusText = translationsArray.finished;
                break;
            case BONUS.STATUSES.ONGOING:
                image = '/dist/playfina_new/images/icons/verification-active.svg';
                statusText = translationsArray.active_now;
                buttonsHtml += '<div class="row no-gutters mt-15">';
                let buttonClass = '';
                let buttonHref = '/lobby';
                if (bonus.games ?? false) {
                    buttonHref = bonus.games[0].game_url ?? '/lobby';
                    buttonClass = 'game-link';
                }
                buttonsHtml += '<div class="col-6 pr-5"><a href="' + buttonHref + '" style="width: 100%; height: 100%" class="d-block deposit-button text-white text-center fz-14 fw-600 ' + buttonClass + '" data-id="' + bonus.api_id + '" data-type="' + bonus.type + '">'  + translationsArray.play +  '</a></div>';
                buttonsHtml += '<div class="col-6 pl-5"><button class="save-button c-200 fz-15 fw-600 cabinet-bonuses__cancel-button" data-id="' + bonus.api_id + '" data-type="' + bonus.type + '">'  + translationsArray.cancel +  '</button></div>';
                buttonsHtml += '</div>';
                break;
        }

        let html = '<div class="col-12 mb-10"><div class="active-bonuses-hc">';

        html += '<div class="row mb-15">'
        html += '<div class="col"><h2 style="text-align: left; margin-bottom: 5px !important;">' + bonus.name + '</h2></div>';

        html += '<div class="col-auto"><div class="verificiation-information"><div class="row no-gutters align-items-center">';

        html += '<div class="col-auto"><img src="' + image + '" alt="" loading="lazy" currentlyloading="true"></div><div class="col"> <p class="c-200 fz-14 fw-600">' + statusText + '</p></div>'

        html += '</div></div></div></div>';

        html += '<div class="row">';
        html += '<div class="col">';

        let progressBarHtml = '';
        if (bonus.type == BONUS.TYPES.FREESPIN) {
            progressBarHtml = '<div class="missions-p"><h4><strong>' + bonus.amount + '</strong> FS</h4><span class="missions-p-c" style="visibility: hidden;"><span style="width: 0%;"></span></span></div>';
        } else if (bonus.type == BONUS.TYPES.JACKPOT_WIN) {
            progressBarHtml = '<div class="missions-p"><h4>' + (bonus.short_name ? (bonus.short_name + ' ') : '' ) + bonus.amount + bonus.currency_symbol + '</h4></div>';
        } else { // cash
            let barPercent = (bonus.amount_wagered / bonus.wager_required) * 100;
            progressBarHtml = '<div class="missions-p"><h4><strong>' + bonus.amount_wagered + '</strong> / ' + bonus.wager_required + bonus.currency_symbol + '</h4><span class="missions-p-c"><span style="width: ' + barPercent + '%;"></span></span></div>';
        }
        html += progressBarHtml;
        html += '<p class="mb-5">' + translationsArray.valid_until + ': ' + validUntil + '</p><p>' + translationsArray.time_left + ': <span class="cabinet-bonuses__new-timer" data-time="' + timerSeconds + '"></span></p>';
        html += '</div>';

        let bonusImage = '/dist/playfina_new/images/examples/Gift proifle 4.webp';
        if (bonus.deposit_image) bonusImage = bonus.deposit_image;
        else if (bonus.image) bonusImage = bonus.image;

        html += '<div class="col-auto"><picture><img src="' + bonusImage + '" alt="" loading="lazy" class="image-fit"></picture></div>'
        html += '</div>';

        html += buttonsHtml;

        html += '</div></div>';

        return html;
    }

    const formatTime = (seconds) => {
        return Math.floor(seconds / 3600) + ' ' + translationsArray.hours_h + ' : ' + Math.floor((seconds % 3600) / 60) + ' ' + translationsArray.minutes_min;
    }

    const refreshSection = () => {
        getActivePromotions().then((data) => {
            const promotions = data.data.hasOwnProperty('bonuses') ? data.data.bonuses.sort((first, second) => first.api_id < second.api_id ? -1 : 1) : null;
            if (!promotions || !promotions.length) {
                inactiveSections.removeClass('d-none');
                activeSections.addClass('d-none');
                desktopSimpleBar?.recalculate();
                mobileSimpleBar?.recalculate();
                return;
            }

            const activeBonusHtml = promotions.map(generateActiveBonusHtml).join('')
            activeSections.each((idx, element) => { $(element).html(activeBonusHtml); });

            inactiveSections.addClass('d-none');
            activeSections.removeClass('d-none');

            activeSections.find('.cabinet-bonuses__new-timer').each(function() {
                const element = $(this);
                let seconds = Number(element.attr('data-time'));
                seconds = seconds - (seconds % 60);
                element.text(formatTime(seconds));

                let interval = setInterval(() => {
                    seconds -= 60;
                    element.text(formatTime(seconds));

                    if (seconds <= 0) clearInterval(interval);
                }, 60000) // once every 60s
            });

            desktopSimpleBar?.recalculate();
            mobileSimpleBar?.recalculate();
        });
    }

    $('body').on('mainCurrencyChange', function (event, currency) {
        populateDepositButtonAmount(currency);
    });

    refreshSection();
    populateDepositButtonAmount(userCurrency);

    modal.on('show.bs.modal', refreshSection);
    $('body').on('bonusesUpdate', refreshSection);
});